import { isCwfDebugControlsEnabled } from "@/lib/cwfDebugControls";

/** Session flag: allow `/welcome` while profile is already complete (home debug replay). */
export const CWF_DEBUG_REPLAY_WELCOME_KEY = "cwf-debug-replay-welcome";

export function isHomeDebugMenuEnabled(): boolean {
  return isCwfDebugControlsEnabled();
}

export function setReplayWelcomeDebugFlag(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(CWF_DEBUG_REPLAY_WELCOME_KEY, "1");
  } catch {
    /* private mode / quota */
  }
}

export function hasReplayWelcomeDebugFlag(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return sessionStorage.getItem(CWF_DEBUG_REPLAY_WELCOME_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearReplayWelcomeDebugFlag(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(CWF_DEBUG_REPLAY_WELCOME_KEY);
  } catch {
    /* noop */
  }
}
